import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Header} from './components/Header';
import reportWebVitals from './reportWebVitals';
import { MediaQueryProvider } from './components/provider/MediaQueryProvider';
import MainComponent from './components/pages/MainComponent';

const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    {/* <MediaQueryProvider>
    </MediaQueryProvider> */}
    {/* <App />
    <Header /> */}

    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
